// removed by extract-text-webpack-plugin
module.exports = {"message":"T2IaAFeeMl4usSKKnsoYq"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Components/MessageFooter/style.css
// module id = 380
// module chunks = 39